<template>
  <div class="the-header">
    <v-app-bar
      app
      fixed
      v-scroll="checkAppBarStatus"
      color="transparent"
      :class="{ primary: !zeroScroll }"
      elevate-on-scroll
      dense
      :dark="!zeroScroll"
      height="50"
    >
      <!-- height="" -->
      <!-- links -->
      <div class="links hidden-sm-and-down">
        <v-btn text v-for="(item, itemInd) in links" :key="itemInd" small>
          <v-img
            class="ml-1"
            :class="{ 'white-img': !zeroScroll }"
            max-height="23"
            max-width="22"
            height="23"
            contain
            :src="require(`@/assets/imgs/TheHeader/links/${item.img}.png`)"
          />
          <span>{{ item.title }}</span>
        </v-btn>
      </div>
      <v-spacer />
      <!-- social -->
      <div
        class="
          social-links
          d-flex
          align-center
          flex-column flex-sm-row
          justify-center
        "
      >
        <div class="email d-flex align-center">
          <!-- email -->
          <a href="mailto:info@Designstore.Ga">
            <span class="text-caption underline">info@Designstore.Ga</span>
          </a>
          <v-img
            class="d-inline-block mr-1"
            src="@/assets/imgs/TheHeader/mail.png"
            contain
            width="25"
            max-width="25"
            height="20"
          />
        </div>
        <!-- phone-numbers -->
        <div class="whatsapp mr-4 d-flex align-center">
          <div class="text-caption d-inline-block">
            <a
              href="https://api.whatsapp.com/send?phone=+201095944347"
              target="_blank"
              class="text-decoration-none"
            >
              <span class="underline">01095944347</span>
            </a>
            <span>- </span>
            <a
              href="https://api.whatsapp.com/send?phone=+2001154154931"
              target="_blank"
              class="text-decoration-none"
            >
              <span class="underline">01154154931</span>
            </a>
          </div>
          <v-img
            src="@/assets/imgs/TheHeader/whatsapp.png"
            class="d-inline-block mr-1"
            contain
            width="25"
            max-width="25"
          />
        </div>
      </div>
      <v-spacer class="hidden-md-and-up" />
      <v-app-bar-nav-icon
        class="hidden-md-and-up"
        @click.stop="drawer = !drawer"
      >
      </v-app-bar-nav-icon>
    </v-app-bar>
    <!-- navigation -->
    <v-navigation-drawer
      app
      nav
      v-model="drawer"
      disable-resize-watcher
      disable-route-watcher
    >
      <v-sheet min-height="80" color="transparent" class="d-flex flex-column">
        <!-- <div class="text-h6">Design Store</div> -->
        <div class="pa-2 ml-auto">
          <v-btn icon @click.stop="drawer = false">
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        <!--  -->
        <v-img
          src="@/assets/imgs/TheHeader/logo.png"
          contain
          max-height="125"
        />
      </v-sheet>
      <v-divider />
      <v-list nav dense>
        <template v-for="(item, itemInd) in links">
          <v-list-item :key="itemInd" dense link>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-img
                :src="require(`@/assets/imgs/TheHeader/links/${item.img}.png`)"
                max-width="30"
                contain
              />
            </v-list-item-icon>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  data: () => ({
    zeroScroll: true,
    drawer: false,
    links: [
      {
        title: "الرئيسية",
        icon: "mdi-home",
        img: "home",
      },
      {
        title: "نمازج اعمالنا",
        icon: "mdi-",
        img: "project",
      },
      {
        title: "صفحتنا علي الفيسبوك",
        icon: "mdi-",
        img: "facebook",
      },
      {
        title: "اتصل بنا",
        icon: "mdi-",
        img: "contactus",
      },
    ],
  }),
  methods: {
    checkAppBarStatus() {
      const state = 0;
      // scrollY <= 10 => transparent | .app-bar-bg
      if (window.scrollY > state) {
        this.zeroScroll = false;
      } else {
        this.zeroScroll = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.app-bar-bg {
  background: none !important;
  backdrop-filter: blur(16px);
  background-color: transparent !important;
}
.underline {
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
.white-img {
  filter: invert(1%) sepia(1%) saturate(1%) hue-rotate(1deg) brightness(1000%)
    contrast(80%);
}
</style>